module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/stock-ac940e12c2c3b0381982481ae633db97.svg";